import { render, staticRenderFns } from "./MasterDataModal.vue?vue&type=template&id=05645ad8&scoped=true"
import script from "./MasterDataModal.vue?vue&type=script&lang=js"
export * from "./MasterDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05645ad8",
  null
  
)

export default component.exports